import { Navigate, Routes } from "react-router-dom";
import PDFDemo from "../components/PDFDemo";
import Billing from "../components/billing";
import Extraction from "../features/extraction";
import Extractions from "../features/extractions";
import Imports from "../features/imports";
import Main from "../features/layouts/main";
import PipelineImport from "../features/pipelineImport";
import PipelineImports from "../features/pipelineImports";
import Reconciliation from "../features/reconciliation";
import Reconciliations from "../features/reconciliations";
import Schema from "../features/schema";
import Schemas from "../features/schemas";
import SettingsPage from "../features/settingsPage";
import Users from "../features/users";
import Welcome from "../features/welcome";
import parseRoutes from "./utils/parseRoutes";
import ImporterRoutes from "./ImporterRoutes";

enum FeatureGroup {
  Imports = "imports",
  Importers = "importers",
  Extractions = "extractions",
}

const cloudRoutes = [
  {
    paths: "importers/*",
    children: <ImporterRoutes />,
    featureGroup: FeatureGroup.Importers,
  },
  {
    paths: "schemas",
    layout: Main,
    featureGroup: FeatureGroup.Imports,
    children: <Schemas />,
  },
  {
    paths: "schema/:schemaId",
    layout: Main,
    featureGroup: FeatureGroup.Imports,
    children: <Schema />,
  },
  {
    paths: "imports",
    layout: Main,
    featureGroup: FeatureGroup.Imports,
    children: <PipelineImports />,
  },
  {
    paths: "extractions",
    layout: Main,
    featureGroup: FeatureGroup.Extractions,
    children: <Extractions />,
  },
  {
    paths: "import/:importId",
    featureGroup: FeatureGroup.Imports,
    layout: Main,
    children: <PipelineImport />,
  },
  {
    paths: "data",
    featureGroup: FeatureGroup.Importers,
    layout: Main,
    children: <Imports />,
  },
  {
    paths: "extraction/:extractionId",
    layout: Main,
    featureGroup: FeatureGroup.Extractions,
    children: <Extraction />,
  },
  {
    paths: "settings",
    layout: Main,
    children: <SettingsPage />,
  },
  {
    paths: "billing",
    layout: Main,
    children: <Billing />,
    featureGroup: FeatureGroup.Importers,
  },
  // {
  //   paths: "billing/plans",
  //   layout: Main,
  //   children: <Plans />,
  // },
  {
    paths: "users",
    layout: Main,
    children: <Users />,
  },
  {
    paths: "getting-started",
    layout: Main,
    children: <Welcome />,
    featureGroup: FeatureGroup.Importers,
  },
  {
    paths: "demo",
    children: <Navigate to="/extraction-demo" replace />,
  },
  {
    paths: "demo/*",
    children: <Navigate to="/extraction-demo" replace />,
  },
  {
    paths: "extraction-demo",
    children: <PDFDemo />,
  },
  {
    paths: "extraction-demo/*",
    children: <PDFDemo />,
  },
  {
    paths: "reconciliation/:reconciliationId",
    layout: Main,
    featureGroup: FeatureGroup.Extractions,
    children: <Reconciliation />,
  },
  {
    paths: "reconciliations",
    layout: Main,
    featureGroup: FeatureGroup.Extractions,
    children: <Reconciliations />,
  },
];

export default function ApplicationRoutes({ hasPipelinesAccess }: { hasPipelinesAccess: boolean }) {
  const isFirstLogin = localStorage.getItem("isFirstLogin");
  const defaultRoute = hasPipelinesAccess ? "imports" : isFirstLogin === null ? "getting-started" : "importers";
  const routeGroup = hasPipelinesAccess ? FeatureGroup.Imports : FeatureGroup.Importers;
  const routes = [
    ...cloudRoutes.filter(({ featureGroup }) => !featureGroup || featureGroup === routeGroup || featureGroup === FeatureGroup.Extractions),
    {
      paths: "*",
      children: <Navigate to={defaultRoute} />,
    },
  ];
  return <Routes>{parseRoutes(routes)}</Routes>;
}
